import z from "zod";

export function getCurrentUrl() {
  let url = null;
  const href = typeof window !== "undefined" ? window.location.href : "";
  try {
    url = new URL(href);
  } catch {
    url = new URL("http://localhost");
  }
  return `${url.origin}${url.pathname}`;
}

export function makeFacebookShareLink(url: string) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url
  )}`;
}

export function makeEmailLink(url: string) {
  return `mailto:?body=${encodeURIComponent(url)}`;
}

export function makeTwitterShareLink(url: string) {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
}

export function makeLinkedInShareLink(url: string) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    url
  )}`;
}

export function makeMastodonShareLink(url: string) {
  return `https://mastodon.social/share?text=${encodeURIComponent(url)}`;
}

export const DOI_ORG = "https://doi.org/";

export function isUrl(str: string) {
  return z.string().url().safeParse(str).success;
}

export function transformDoiOrUrl(doiOrUrl: string) {
  if (isUrl(doiOrUrl)) {
    return doiOrUrl;
  }
  return new URL(doiOrUrl, DOI_ORG).toString();
}

export function makeEditorImageUrl(uploadId: string, apiUrl: string) {
  return new URL(`/api/editor/uploads/${uploadId}`, apiUrl).toString();
}

export function makeRendererImageUrl(uploadId: string, apiUrl: string) {
  return new URL(`/api/renderer/uploads/${uploadId}`, apiUrl).toString();
}
